import { enumToI18nKey } from '~/utils/helpers';

export const GROUP_STATUS = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
} as { [key: string]: GroupsApi.eGroupStatus };

export const GROUP_STATUS_I18n = enumToI18nKey(GROUP_STATUS, 'GROUP_STATUS');